module.exports = __webpack_public_path__ + "old_smart_pass_icon-b6d8f.svg";